<script setup>
import { inject, ref, watch } from 'vue';
import InputFechaHora from '../cifra/InputFechaHora.vue';

const { t } = inject('I18n');

// Los tipos de patologías son los que ya están en el enumerado, para no repetirlos
const tipos = t('activerecord.enums.patologia.tipo');

const props = defineProps({
  patologia: { type: Object, default: null },
  disabled: { type: Boolean, default: false }
});

const emit = defineEmits(['close', 'saved']);

const PATOLOGIA_DEFECTO = {
  fecha_inicio: '',
  fecha_fin: '',
  tipo: '',
  descripcion: ''
};

const form = ref({ ...PATOLOGIA_DEFECTO });

watch(
  () => props.patologia,
  (val) => {
    if (val) {
      form.value = { ...val };
    } else {
      form.value = { ...PATOLOGIA_DEFECTO };
    }
  },
  { immediate: true }
);

function guardar() {
  emit('saved', { ...form.value });
}
</script>

<template>
  <form @submit.prevent="guardar">
    <div class="row">
      <div class="col-xs-4">
        <InputFechaHora v-model="form.fecha_inicio" :required="true" :label="t('Fecha_inicio')" />
      </div>
      <div class="col-xs-6">
        <InputFechaHora v-model="form.fecha_fin" :label="t('Fecha_fin')" />
      </div>
    </div>
    <div class="form-group">
      <label class="control-label" v-campo-requerido>
        {{ t('Tipo') }}
      </label>
      <select v-model="form.tipo" required class="form-control">
        <option value="">{{ t('Seleccionar') }}</option>
        <option v-for="(label, tipo) in tipos" :key="tipo" :value="tipo">{{ label }}</option>
      </select>
    </div>
    <div class="form-group">
      <label class="control-label" v-campo-requerido>
        {{ t('Descripcion') }}
      </label>
      <textarea v-model="form.descripcion" required rows="4" class="form-control"></textarea>
    </div>
    <div class="form-actions" v-if="!disabled">
      <button type="button" class="btn btn-default" data-dismiss="modal" @click="$emit('close')">{{ t('Cancelar') }}</button>
      <button type="submit" class="btn btn-primary">{{ t('Guardar') }}</button>
    </div>
  </form>
</template>
